import { render, staticRenderFns } from "./PurchaseNote.vue?vue&type=template&id=3ed286f9&"
import script from "./PurchaseNote.vue?vue&type=script&lang=js&"
export * from "./PurchaseNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports